const Navigation = () => {
    return (
        <nav className="d-flex flex-row justify-content-between">
            <p className="title">Where in the World?</p>
        </nav>
    )
}
export default Navigation;